import { Controller } from "@hotwired/stimulus"

// Keeps the active sidebar link highlight in sync with the current URL.
// Needed because the sidebar uses data-turbo-permanent (so it does NOT re-render
// across Turbo navigations), but the active class is otherwise computed
// server-side from current_page?/request.path.
//
// Matches the classes applied by ApplicationHelper#sidebar_link.
const ACTIVE_CLASSES = [
  "bg-primary/10",
  "text-primary",
  "font-medium",
  "border-l-3",
  "border-primary",
  "hover:bg-primary/20",
]

export default class extends Controller {
  connect() {
    this.update()
    this._boundUpdate = () => this.update()
    document.addEventListener("turbo:load", this._boundUpdate)
    document.addEventListener("turbo:render", this._boundUpdate)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this._boundUpdate)
    document.removeEventListener("turbo:render", this._boundUpdate)
  }

  update() {
    const path = window.location.pathname
    const links = this.element.querySelectorAll("nav a[href]")
    // Find longest-prefix match so e.g. /admin/plants/123/edit highlights Plants.
    let best = null
    let bestLen = 0
    links.forEach(a => {
      const href = a.getAttribute("href")
      if (!href || href === "#") return
      if (path === href || path.startsWith(href + "/")) {
        if (href.length > bestLen) { best = a; bestLen = href.length }
      }
    })
    links.forEach(a => a.classList.remove(...ACTIVE_CLASSES))
    if (best) best.classList.add(...ACTIVE_CLASSES)
  }
}
